export const AlertTypeLine = "LINE"